<template>
  <div class="button-tile-item">
    <div>
      <div v-if="!simpleTiles" class="color-margin"></div>
      <v-img class="button-tile-img" :src="imageUrl" />
    </div>

    <div class="button-tile-content">
      <div v-if="!simpleTiles" class="title-tile">{{ title }}</div>
      <div class="description" :class="{ 'description-simple': simpleTiles }">
        {{ description }}
      </div>
    </div>
    <div v-if="!simpleTiles" class="btn-container">
      <FunkButton
        button-text="How It Works"
        @buttonClicked="handleClick"
      ></FunkButton>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonTile",
  props: {
    imageUrl: {
      required: true,
      default: "",
      type: String,
    },
    title: {
      required: true,
      default: "",
      type: String,
    },
    description: {
      required: true,
      default: "",
      type: String,
    },
    simpleTiles: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "HowItWorks" });
    },
  },
};
</script>

<style scoped lang="scss">
.button-tile-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  overflow: hidden;

  .button-tile-img {
    max-height: 138px;
  }

  .color-margin {
    background-color: #ed0080;
    height: 8px;
  }

  .button-tile-content {
    padding: 24px;
    padding-bottom: 31px;
    display: flex;
    flex-direction: column;

    .title-tile {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 8px;
      color: var(--v-light-primary-text-colour-base, "#282828");
      font-feature-settings: "clig" off, "liga" off;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
    }
    .description {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      color: #282828;
      font-feature-settings: "clig" off, "liga" off;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
    }
    .description-simple {
      font-size: 16px;
      font-weight: 500;
    }
  }
  .btn-container {
    margin-top: auto;
    padding: 0 24px 30px 24px;
  }
}
</style>
